export default "__VITE_ASSET__DUgPe_7o__"